import React from "react";
import "./Spinner.css"; // Import the CSS file for styling

const ReusableSpinner = () => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner-container">
        <div className="loading-circle"></div>
      </div>
    </div>
  );
};


export default ReusableSpinner;

